/** Hands a file to the browser's download, without leaving the page. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Semicolon CSV like the server export; cells that look like formulas stay inert. */
export function recordsCsv(records: readonly Record<string, unknown>[]): string {
  const columns: string[] = [];
  for (const record of records) for (const key of Object.keys(record)) if (!columns.includes(key)) columns.push(key);
  const cell = (value: unknown) => {
    let text = value == null ? "" : typeof value === "object" ? JSON.stringify(value) : String(value);
    if (/^[\s]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = `'${text}`;
    return /[;"\r\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
  };
  return "﻿" + [columns.join(";"), ...records.map((record) => columns.map((column) => cell(record[column])).join(";"))].join("\r\n");
}
